import React, { useEffect, useState } from "react";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../firebase"; // adjust path if needed

import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import ContactSection from "../components/ContactSection";
import PageLines from "../components/PageLines";
import CustomLoader from "../components/CustomLoader";

function DesignerCard({ designer }) {
  return (
    <article className="blog mb-12">
      <div className="row">
        <div className="blog-thumbnail col-md-8">
          <div
            className="blog-thumbnail-bg col-md-8 visible-md visible-lg"
            style={{
              backgroundImage: `url(${
                designer.image || "/img/blog/placeholder.jpg"
              })`,
            }}
          />
          <div className="blog-thumbnail-img visible-xs visible-sm">
            <img
              src={designer.image || "/img/blog/placeholder.jpg"}
              alt="thumbnail"
              className="img-responsive"
            />
          </div>
        </div>

        <div className="blog-info col-md-4 flex flex-col justify-between">
          <div>
            {/* ✅ Engineer image slot */}
            <div className="w-20 h-20 ml-2">
              <img
                src={designer.engineerImage || "/img/engineer/FARAH.JPG"}
                alt="Engineer"
                className="w-full h-full object-cover rounded"
                width={"50%"}
                height={"50%"}
                style={{ borderRadius: "15%" }}
              />
            </div>
            <br />
            <div className="blog-tags space-x-1">
              {designer.tags?.map((t, index) => (
                <a key={index}>{t}</a>
              ))}
            </div>

            <h3 className="blog-title mt-2 text-lg font-bold leading-tight">
              <a>{designer.name}</a>
            </h3>
            <p className="mt-2 text-sm opacity-80">{designer.excerpt}</p>
          </div>

          <div className="blog-meta mt-4 flex items-center justify-between text-xs uppercase tracking-widest opacity-60">
            <div className="author">
              by <a>Xin Chuan</a>
            </div>
            <div className="time">July&nbsp;26</div>
          </div>

          <div className="text-right mt-4">
            <a className="read-more">Project Completed</a>
          </div>
        </div>
      </div>
    </article>
  );
}

export default function Designer() {
  const [designers, setDesigners] = useState([]);
  const [visibleCount, setVisibleCount] = useState(4);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Hide loader after 2 seconds
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    async function fetchDesigners() {
      const querySnapshot = await getDocs(collection(db, "designers"));
      const data = querySnapshot.docs
        .map((doc) => {
          const d = doc.data();
          return {
            id: doc.id,
            sortNum: parseInt(doc.id.replace("designer", "")) || 0, // extract number
            name: d.name,
            engineerImage: d.EngImageUrl || "",
            excerpt: `With ${d.experience} experience, specialises in ${d.expert1}, ${d.expert2}, and ${d.expert3}.`,
            tags: [
              "4 completed projects",
              `Expert in ${d.expert1}`,
              `Expert in ${d.expert2}`,
              `Expert in ${d.expert3}`,
            ],
            image: "/img/blog/1-760x514.jpg",
          };
        })
        .sort((a, b) => b.sortNum - a.sortNum); // sort descending

      setDesigners(data);
    }

    fetchDesigners();
  }, []);

  return (
    <div className="layout">
      {/* Custom Loader */}
      {isLoading && <CustomLoader />}
      <main
        className="main main-inner main-blog bg-blog"
        style={{
          backgroundImage: "url('/img/xinchuan/xinchuan_office2.jpg')",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="container">
          <header className="main-header">
            <h1>Designer Hire</h1>
          </header>
        </div>
      </main>

      <div className="content">
        <section className="blog-list py-16">
          <div className="container">
            {designers.slice(0, visibleCount).map((d) => (
              <DesignerCard key={d.id} designer={d} />
            ))}

            <div className="section-content text-center mt-10">
              {visibleCount < designers.length && (
                <button
                  className="btn btn-gray"
                  onClick={() => setVisibleCount(designers.length)}
                >
                  Read More
                </button>
              )}
            </div>
          </div>
        </section>

        <ContactSection />
        <Footer />
        <PageLines />
      </div>
    </div>
  );
}
